import { RefObject } from "react"
import { SETUP_GOALS, SetupGoal } from "connected-components/optimize-experiments/constants"
import { CONSTRAINTS } from "modules/optimization-settings/selectors/constraints"

export interface SetupSection {
  goal: SetupGoal
}

export interface RulesSection {
  maxTurnover: number | string
}

export interface DefaultConfiguration {
  setup: SetupSection
  rules: RulesSection
}
// Union of SetupSection and RulesSection interfaces
export type ConfigurationSection = DefaultConfiguration[keyof DefaultConfiguration]

// Union of the keys of the DefaultConfiguration interface
export type SectionName = keyof DefaultConfiguration

export interface SectionConfig<T> {
  state: T
  setState: (state: T) => void
  latestRef: RefObject<T>
  initialRef: RefObject<T>
}

export type ConfigurationSections = {
  [K in keyof DefaultConfiguration]: SectionConfig<DefaultConfiguration[K]>
}

export const createConfigurationSections = (sections: {
  setup: SetupSection
  setSetup: (state: SetupSection) => void
  latestSetup: RefObject<SetupSection>
  initialSetupValues: RefObject<SetupSection>
  rules: RulesSection
  setRules: (state: RulesSection) => void
  latestRules: RefObject<RulesSection>
  initialRulesValues: RefObject<RulesSection>
}): ConfigurationSections => ({
  setup: {
    state: sections.setup,
    setState: sections.setSetup,
    latestRef: sections.latestSetup,
    initialRef: sections.initialSetupValues,
  },
  rules: {
    state: sections.rules,
    setState: sections.setRules,
    latestRef: sections.latestRules,
    initialRef: sections.initialRulesValues,
  },
})

const DEFAULT_SETUP: SetupSection = {
  goal: SETUP_GOALS.MINIMIZE_TOTAL_RISK,
}

const DEFAULT_RULES: RulesSection = {
  maxTurnover: CONSTRAINTS.maxTurnover().defaultValue,
}

export const DEFAULT_CONFIGURATION: DefaultConfiguration = {
  setup: DEFAULT_SETUP,
  rules: DEFAULT_RULES,
}
